import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import {
  Table,
  TableContainer,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  CircularProgress,
  Typography,
  Box,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField, IconButton, Divider,
  Grid
} from '@mui/material';
import axios, { decryptData } from '../Axiosinstance';
import ExcelJS from 'exceljs';
import { Add, Delete } from '@mui/icons-material';
import { ToastContainer, toast } from 'react-toastify';
import CloseIcon from '@mui/icons-material/Close';
import EditSessionModule from './Invoiceclick/EditSessionModule';
import Juro from './Juro.png';

import 'react-toastify/dist/ReactToastify.css';
const AttendanceSheet = () => {
  const [studentdata, setStudentdata] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [open, setOpen] = useState(false);
  const [openModuleModal, setOpenModuleModal] = useState(false);
  const [editableWeeks, setEditableWeeks] = useState([]);
  const [selectedScheduleId, setSelectedScheduleId] = useState(null);
  const [selectedStudentId, setSelectedStudentId] = useState(null);
  const [studentdata1, setStudentdata1] = useState([]);
  const [selectedWeek, setSelectedWeek] = useState(null); // State to track the selected week
  const [selectedDate, setSelectedDate] = useState(null); // State to track the selected date
  const { intakeId } = useParams();
  const intakeId1 = decryptData(decodeURIComponent(intakeId));
  const [dateID, setDateID] = useState();
  const [weekID, setWeekID] = useState();



  const fetchData = async () => {
    try {
      const response = await axios.get(`/intake-details/intakeId/${intakeId1}`);
      if (response.data) {
        console.log('API Response:', response.data);
        setStudentdata([response.data]);
        console.log("Intake details student data:", response.data);
      } else {
        throw new Error('Data format is incorrect');
      }
    } catch (error) {
      console.error('Fetch error:', error);
      setError(error.message || 'An error occurred');
    } finally {
      setLoading(false);
    }
  };

  // Fetch data on component mount or when intakeId1 changes
  useEffect(() => {
    fetchData();
  }, [intakeId1]);


  useEffect(() => {
    const fetchStudentData1 = async () => {
      try {
        const response = await axios.get(`/registrationadvances/registration/active?intakeId=${intakeId1}`);
        if (response.data) {

          setStudentdata1(response.data);
          console.log("registrationadvances studentdata1", response.data)

        } else {
          throw new Error('Data format is incorrect');
        }
      } catch (error) {
        console.error('Fetch error:', error);
        setError(error.message || 'An error occurred');
      }
    };

    fetchStudentData1();
  }, [intakeId, intakeId1]);

  const handleClickOpen = (weeks, scheduleId, studentId) => {
    // Set the editableWeeks state and other necessary states based on passed data
    setEditableWeeks(weeks);
    setSelectedScheduleId(scheduleId);
    setSelectedStudentId(studentId);
    setOpen(true); // Opens the dialog
  };

  const handleOpenModal = (scheduleId) => {
    setSelectedScheduleId(scheduleId);
    setOpenModuleModal(true);
  };

  const handleCloseModal = () => {
    setSelectedScheduleId(null);
    setOpenModuleModal(false);
  };

  const handleWeekSelection = (week) => {
    console.log(week);  // Check the structure of the week object
    setWeekID(week.id);  // Assuming `week.id` is the ID for the selected week
    setSelectedWeek(week.id);
  };


  const handleDateSelection = (date) => {
    setDateID(date.id);  // Assuming `date.id` is the ID for the selected date
    setSelectedDate(date.id);
  };

  const handleClose = () => {
    setOpen(false);
    setEditableWeeks([]);
    setSelectedScheduleId(null);
    setSelectedStudentId(null);
    setSelectedDate(null);
    setSelectedWeek(null);
  };

  const handleDateChange = (e, weekId, dateId) => {
    // Get the selected date value
    const newDate = e.target.value;

    // Determine the day of the week for the new date
    const newDay = new Date(newDate).toLocaleString('en-us', { weekday: 'long' });

    // Update the date and day for the selected week and date
    const updatedWeeks = editableWeeks.map((week) => {
      if (week.id === weekId) {
        const updatedDates = week.dates.map((date) => {
          if (date.id === dateId) {
            return { ...date, date: newDate, day: newDay }; // Set the new date and corresponding day
          }
          return date;
        });
        return { ...week, dates: updatedDates };
      }
      return week;
    });

    setEditableWeeks(updatedWeeks);
  };



  const handleDayChange = (e, weekId, dateId) => {
    // Update the day value for the selected week and date
    const updatedWeeks = editableWeeks.map((week) => {
      if (week.id === weekId) {
        const updatedDates = week.dates.map((date) => {
          if (date.id === dateId) {
            return { ...date, day: e.target.value };
          }
          return date;
        });
        return { ...week, dates: updatedDates };
      }
      return week;
    });

    setEditableWeeks(updatedWeeks);
  };



  const handleStartTimeChange = (e, weekId, dateId, sessionName) => {
    const updatedWeeks = editableWeeks.map((week) => {
      if (week.id === weekId) {
        const updatedDates = week.dates.map((date) => {
          if (date.id === dateId) {
            const updatedSessions = { ...date.sessions };
            updatedSessions[sessionName] = {
              ...updatedSessions[sessionName],
              startTime: e.target.value,
            };
            return { ...date, sessions: updatedSessions };
          }
          return date;
        });
        return { ...week, dates: updatedDates };
      }
      return week;
    });

    setEditableWeeks(updatedWeeks);
  };


  // Function to handle end time change
  const handleEndTimeChange = (e, weekId, dateId, sessionName) => {
    const updatedWeeks = editableWeeks.map((week) => {
      if (week.id === weekId) {
        const updatedDates = week.dates.map((date) => {
          if (date.id === dateId) {
            const updatedSessions = { ...date.sessions };
            updatedSessions[sessionName] = {
              ...updatedSessions[sessionName],
              endTime: e.target.value,
            };
            return { ...date, sessions: updatedSessions };
          }
          return date;
        });
        return { ...week, dates: updatedDates };
      }
      return week;
    });

    setEditableWeeks(updatedWeeks);
  };


  const handleSaveChanges = async () => {
    try {
      console.log('Datddda to send:', editableWeeks);
      // Collect the necessary details from your state
      const selectedWeekData = editableWeeks.find(week => week.id === selectedWeek);  // Find the selected week
      const selectedDateData = selectedWeekData.dates.find(date => date.id === selectedDate); // Find the selected date

      // Check if sessions exist and is an object (not an array), if not initialize it as an empty object
      const sessions = selectedDateData.sessions || {};

      const formattedSessions = {};
      // Loop over the sessions object and format the session data
      Object.keys(sessions).forEach(sessionKey => {
        const session = sessions[sessionKey];
        formattedSessions[sessionKey] = {
          startTime: session.startTime,
          endTime: session.endTime
        };
      });

      // Construct the payload with the selected details
      const dataToSend = {
        intakeDetailsId: intakeId1,  // assuming this is part of selectedWeek
        scheduleDateId: selectedScheduleId, // assuming this is part of selectedDate
        weekId: weekID,
        dateId: dateID,
        date: selectedDateData.date, // Include the updated date
        day: selectedDateData.day,  // Include the updated day
        sessions: formattedSessions, // formatted sessions object
      };

      console.log('Data to send:', dataToSend);

      // Make the PUT request to the API
      const response = await axios.put('/intake-details/update-sessions', dataToSend);
      toast.success("Intake Updated Sucessfully");
      fetchData();

    } catch (error) {
      console.error('Error updating sessions:', error);
      // Optionally, show an error message
      // Example: setErrorMessage('Failed to update sessions. Please try again.');
    }
  };

  const ExcelJS = require('exceljs'); // Ensure you have ExcelJS installed
  const { saveAs } = require('file-saver'); // Ensure you have file-saver installed


  const getImageAsBase64 = async (imageUrl) => {
    const response = await fetch(imageUrl); // Fetch the image (from the public folder or URL)
    const imageBlob = await response.blob(); // Convert the image to a Blob
    const reader = new FileReader();

    return new Promise((resolve, reject) => {
      reader.onloadend = () => resolve(reader.result); // The result is the Base64 string
      reader.onerror = reject; // If there's an error reading the file
      reader.readAsDataURL(imageBlob); // Read the image as a Base64 string
    });
  };
  
  const addBorders = (worksheet) => {
    worksheet.eachRow({ includeEmpty: true }, (row, rowIndex) => {
      row.eachCell({ includeEmpty: true }, (cell, colIndex) => {
        // Skip adding borders for empty cells in row 10
        if (rowIndex === 10 && !cell.value) {
          return; // Skip this empty cell
        }

        // Set the border for all other cells
        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' }
        };
      });
    });
  };

  const exportToExcel = async (weeksData, courseName, moduleCode, moduleName, intakeId, trainers, scheduleId, studentIntakeIds, nrics, intakeIds, names, studentIds) => {
    console.log("studentids", studentIds)
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Attendance Details');

    worksheet.pageSetup = {
      orientation: 'landscape',
      //  printTitlesRow: '1:5',
      // Configure page setup to repeat row 5 on each pageS
    };

    worksheet.pageSetup.printTitlesColumn = 'A:D';

    worksheet.pageSetup.oddFooter = "hi";
    const base64Image = await getImageAsBase64('/images/Juro.png');  // Use the correct image path

    // Add the image to the workbook using the Base64 string
    const imageId = workbook.addImage({
      base64: base64Image,  // Base64 image string
      extension: 'png',  // Image extension
    });

    // Insert the image into a specific cell (e.g., top-left corner)
    worksheet.addImage(imageId, {
      tl: { col: 0, row: 0 }, // Position at top-left corner (A1 cell)
      ext: { width: 275, height: 38, }, // Resize image
    });

    // Filter scheduleDetails based on provided scheduleId
    const selectedSchedule = studentdata[0]?.scheduleDateDetails.find(schedule => schedule.id === scheduleId);
    if (!selectedSchedule) {
      throw new Error(`Schedule with ID ${scheduleId} not found.`);
    }

    // Fetch attendance data for all dates in the schedule
    let allApiData = [];
    // Collect all dates into a comma-separated string
    const dates = selectedSchedule.weeks.flatMap(week => week.dates.map(date => date.date)).join(',');

    // Create the API endpoint with the comma-separated list of dates
    const apiEndpoint = `by-intake-and-dates?intakeId=${intakeId}&dates=${dates}`;

    try {
      const response = await axios.get(apiEndpoint);
      allApiData = response.data;  // Assuming the response is an array of data
    } catch (error) {
      console.error('Error fetching data for selected dates:', error);
    }


    // Helper function to convert 24-hour time to 12-hour format
    const convertTo12HourFormat = (time24) => {
      const [hours, minutes] = time24.split(':').map(Number);
      const suffix = hours >= 12 ? 'PM' : 'AM';
      const hours12 = hours % 12 || 12; // Convert 0 hours (midnight) to 12
      const minutes12 = minutes.toString().padStart(2, '0');
      return `${hours12}:${minutes12} ${suffix}`;
    };

    // Helper function to normalize time (omit seconds for comparison)
    const normalizeTime = (time) => {
      console.log(time, "time");

      if (typeof time !== 'string' || !time.includes(' ')) {
        console.warn('Invalid time format:', time);
        return '';
      }

      const [timePart, suffix] = time.split(' ');

      if (!timePart || !timePart.includes(':')) {
        console.warn('Invalid timePart format:', timePart);
        return '';
      }

      const [hoursStr, minutesStr] = timePart.split(':');
      const hours = parseInt(hoursStr, 10);
      const minutes = parseInt(minutesStr, 10);

      if (isNaN(hours) || isNaN(minutes)) {
        console.warn('Invalid numeric time:', timePart);
        return '';
      }

      const normalizedTime = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')} ${suffix}`;
      return normalizedTime;
    };


    // Add headers and schedule details to the worksheet
    worksheet.addRow(['', '', '', '', `${courseName}`, '', '']);
    worksheet.addRow([`Module Code: ${moduleCode}`, '', '', '', `Intake ID: ${intakeId}`]);
    worksheet.addRow([`Trainers: ${trainers.join(', ')}`, '', '', '', '', '']);
    const venue = selectedSchedule?.venue || 'Unknown Venue';
    worksheet.addRow([`Venue: ${venue}`, '', '', '', '', '']);
    const startDate = selectedSchedule?.startDate || 'Unknown Start Date';
    const endDate = selectedSchedule?.endDate || 'Unknown End Date';
    const row = worksheet.addRow([`Start Date: ${startDate}`, '', `End Date: ${endDate}`, '', "SCHEDULE FOR CLASS DATE", '', '', '', '', '', '', '', '']);
    row.getCell(5).font = { bold: true };
    // Add week headers and session details to the worksheet
    const scheduleDetailsRow1 = ['S.No', 'NAME', 'Nric/Fin No', 'IntakeID'];
    const scheduleDetailsRow2 = [];
    const dateRow = [];

    for (let i = 0; i < 4; i++) {
      scheduleDetailsRow2.push(''); // Fill the first 4 columns with placeholders
      dateRow.push('');
    }

    let currentColumnIndex = 5;
    // Helper function to calculate the difference in hours and minutes between two times
    const calculateSessionDuration = (startTime24, endTime24) => {
      const [startHours, startMinutes] = startTime24.split(':').map(Number);
      const [endHours, endMinutes] = endTime24.split(':').map(Number);

      // Convert start and end times to total minutes
      const startTotalMinutes = startHours * 60 + startMinutes;
      const endTotalMinutes = endHours * 60 + endMinutes;

      // Ensure the session time difference is positive (if the end time is after midnight, for example)
      let durationInMinutes = endTotalMinutes - startTotalMinutes;
      if (durationInMinutes < 0) {
        durationInMinutes += 24 * 60; // Add 24 hours in minutes if the end time is before the start time (overnight sessions)
      }

      // Convert back to hours and minutes
      const hours = Math.floor(durationInMinutes / 60);
      const minutes = durationInMinutes % 60;

      return { hours, minutes };
    };

    // Initialize a variable to keep track of total session time in minutes
    let totalSessionTimeInMinutes = 0;



    selectedSchedule.weeks.forEach(week => {
      // Join all dates of the week into a single string (e.g., "2024-11-01, 2024-11-02")
      const weekDates = week.dates.map(date => date.date).join(', '); // Join multiple dates with commas
      const weekNumber = week.weekNumber || 'Unknown Week';
      // scheduleDetailsRow1.push(`${weekDates} Week ${weekNumber}`);
      // const weekHeader = `${weekDates} Week ${weekNumber}`;
      const weekHeader = `Week ${weekNumber}`;

      let sessionStatuses = [];
      let weekDatesForSession = []; // To store the date for each session

      // Helper function to calculate the difference in hours and minutes between two times


      week.dates.forEach(date => {
        if (date.sessions) {
          Object.keys(date.sessions).forEach(sessionName => {
            const session = date.sessions[sessionName];
            const startTime24 = session.startTime;
            const endTime24 = session.endTime;
            console.log(session.startTime, "sessionstarttime");
            // Convert startTime and endTime to 12-hour format
            const startTime12 = convertTo12HourFormat(startTime24);
            const endTime12 = convertTo12HourFormat(endTime24);
            // sessionDetails += `${sessionName}: ${startTime12} - ${endTime12} | `;
            sessionStatuses.push(` ${startTime12}\n -\n ${endTime12}`);
            const { hours, minutes } = calculateSessionDuration(startTime24, endTime24);

            // Add the session time to the total session time in minutes
            totalSessionTimeInMinutes += (hours * 60 + minutes);

            // Add the date corresponding to the session
            weekDatesForSession.push(date.date);
          });
        }
      });


      const sessionCount = sessionStatuses.length;

      scheduleDetailsRow1[currentColumnIndex - 1] = weekHeader;
      if (sessionCount > 1) {
        worksheet.mergeCells(1, currentColumnIndex, 1, currentColumnIndex + sessionCount - 1);
      }

      for (let i = 0; i < sessionCount; i++) {
        scheduleDetailsRow2[currentColumnIndex - 1 + i] = sessionStatuses[i];
      }

      // Add dates corresponding to each session in a separate row
      for (let i = 0; i < sessionCount; i++) {
        dateRow[currentColumnIndex - 1 + i] = weekDatesForSession[i];
      }

      // Update the currentColumnIndex for the next week
      currentColumnIndex += sessionCount;
    });
    // Convert total session time to hours and minutes
    const totalSessionHours = Math.floor(totalSessionTimeInMinutes / 60);
    const totalSessionMinutes = totalSessionTimeInMinutes % 60;

    // Output the total session time (log for debugging)
    console.log(`Total Session Time: ${totalSessionHours} hrs ${totalSessionMinutes} mins`);
    // Column 1 corresponds to "A" in Excel

    // Modify the cell's value


    worksheet.addRow(scheduleDetailsRow1); // Header row
    worksheet.addRow(dateRow);
    worksheet.addRow(scheduleDetailsRow2); // Session details row
    const totalSessionTime = `Total Hrs:${totalSessionHours} hrs ${totalSessionMinutes} mins`;
    const row111 = worksheet.getRow(6);
    row111.getCell(10).value = totalSessionTime;
    worksheet.insertRow(7); // Empty row for spacing

    const sessionAttendanceCounts = [];

    selectedSchedule.weeks.forEach(week => {
      week.dates.forEach(date => {
        if (date.sessions) {
          Object.keys(date.sessions).forEach(sessionName => {
            sessionAttendanceCounts.push({
              sessionName,
              date: date.date,
              present: 0,
              absent: 0
            });
          });
        }
      });
    });

    // Loop through students and match with API data
    const maxLength = Math.max(studentIds.length, nrics.length, intakeIds.length);
    for (let i = 0; i < maxLength; i++) {
      const studentId = studentIds[i] || '';
      const intakeId = intakeIds[i] || '';
      const nric = nrics[i] || '';
      const name = names[i] || '';

      console.log("studentId", studentId)
      const studentRow = [studentId, name, nric, intakeId];
      selectedSchedule.weeks.forEach((week, weekIndex) => {
        week.dates.forEach(date => {
          // Get all matching records for the current date, not just the first one
          const matchingRecords = allApiData.filter(record =>
            record.intakeId === intakeId &&
            record.custom_participant_id === String(studentId) &&
            record.date === date.date &&
            record.preset_name === "group_call_participant"

          );
          console.log(matchingRecords, "matchingRecordsmatchingRecords");
          // Initialize session status array
          let sessionStatuses = [];
          if (matchingRecords.length > 0) {
            // Iterate over sessions for the date
            if (date.sessions) {
              Object.keys(date.sessions).forEach(sessionName => {
                const session = date.sessions[sessionName];
                const startTime24 = session.startTime;

                // Convert session start time to 12-hour format and normalize
                const startTime12 = convertTo12HourFormat(startTime24);
                console.log(startTime12, "startTime12");
                const normalizedSessionStartTime = normalizeTime(startTime12);

                let sessionMatched = false; // Flag to track if session time matched any record
                // Helper function to convert 12-hour time format to Date object (today's date)
                const convertToDateTime = (time) => {
                  const [timePart, suffix] = time.split(' '); // Split into time and AM/PM suffix
                  const [hours, minutes] = timePart.split(':').map(Number);

                  // Create a new Date object for today, set to the provided time
                  const date = new Date();
                  date.setHours(hours % 12 + (suffix === 'PM' ? 12 : 0), minutes, 0, 0);

                  return date;
                };

                // Function to check if two times are within ±15 minutes
                const isWithin15Minutes = (startTime, recordTime) => {
                  const sessionTime = convertToDateTime(startTime); // Session start time
                  const recordDateTime = convertToDateTime(recordTime); // Record time

                  // Calculate the difference in milliseconds
                  const differenceInMilliseconds = Math.abs(sessionTime - recordDateTime);

                  // 15 minutes in milliseconds
                  const fifteenMinutesInMilliseconds = 15 * 60 * 1000;

                  // Return true if the difference is within 15 minutes
                  return differenceInMilliseconds <= fifteenMinutesInMilliseconds;
                };


                // Check each matching record to see if the session start time matches
                matchingRecords.forEach(matchingRecord => {
                  // const normalizedSessionTime = normalizeTime(matchingRecord.time );
                  const normalizedSessionTime = matchingRecord.time ? normalizeTime(matchingRecord.time) : matchingRecord.meeting_start_time
;
                  // console.log(normalizedSessionTime, "normalizedSessionTime");
                   console.log(matchingRecord.time,"test")
                  // If the session start time matches the API record time, get the status
                  if (isWithin15Minutes(normalizedSessionStartTime, normalizedSessionTime) || (normalizedSessionTime == null))   {
                    
                    const status = matchingRecord.status || '-'; // If null or empty, mark as '-'
                     console.log(status, "matchingRecord status");
                    sessionStatuses.push(` ${status}`);
                    sessionMatched = true;

                    // Count present and absent, excluding '-'
                    // if (status === 'P') {
                    //   weekAttendanceCounts[weekIndex].present++;
                    // } else if (status === 'AB') {
                    //   weekAttendanceCounts[weekIndex].absent++;
                    // }
                    if (status === 'P') {
                      sessionAttendanceCounts.forEach(attendance => {
                        if (attendance.sessionName === sessionName && attendance.date === date.date) attendance.present++;
                      });
                    } else if (status === 'AB') {
                      sessionAttendanceCounts.forEach(attendance => {
                        if (attendance.sessionName === sessionName && attendance.date === date.date) attendance.absent++;
                      });

                    }
                  }
                });
                console.log('Session Attendance Counts:', sessionAttendanceCounts);
                // If no matching session time was found, mark the session as absent ('-')
                if (!sessionMatched) {
                  sessionStatuses.push(` -`);

                }
              });
            }
          }

          // If no sessions were matched, mark as '-'
          if (sessionStatuses.length === 0) {
            if (date.sessions) {
              Object.keys(date.sessions).forEach(sessionName => {
                sessionStatuses.push(` -`); // Mark as '-' for each session
              });
            }

          }
          studentRow.push(...sessionStatuses);
          // Append session statuses to student row
          // studentRow.push(sessionStatuses.join(' | '));
        });
      });

      worksheet.addRow(studentRow); // Add the row to the worksheet
    }


    console.log("sessionAttendanceCounts for Present:", sessionAttendanceCounts.map(count => count.present));
    console.log("sessionAttendanceCounts for Absent:", sessionAttendanceCounts.map(count => count.absent));

    const sessionPresentRow = ['No. of Present for Session', '', '', '', ...sessionAttendanceCounts.map(count => count.present)];
    worksheet.addRow(sessionPresentRow);

    const sessionAbsentRow = ['No. of Absent for Session', '', '', '', ...sessionAttendanceCounts.map(count => count.absent)];
    worksheet.addRow(sessionAbsentRow);

    // Add other footer information
    worksheet.addRow(['Signature of Teacher:', '', '', '', '', '']);
    worksheet.addRow(['Note for course Lectures / course facilitators and students:']);
    worksheet.addRow(['Reminder:', '', '', '', '', 'VERIFIED BY: _____________________']);
    worksheet.addRow(['Lecturers are required to authenticate attendance for every student after the completion of each class', '', '', '', '', 'DESIGNATION: Training Manager']);
    worksheet.addRow(['Lecturers are also required to mark attendance of students who are absent or late for lessons', '', '', '', '', 'DATE:']);
    worksheet.addRow(['Students are required to sign in the appropriate columns', '', '', '', '', 'NAME: RABIYATHUL BASARIYA A']);
    worksheet.addRow(['AB: Absent / P: Present / -:Session Not Taken Yet', '', '', '', '', '']);

    // Define the cell references
    const cells = ['A8', 'B8', 'C8', 'D8', 'E2', 'D19'];

    // Apply font style and alignment to each cell
    cells.forEach(cellRef => {
      const cell = worksheet.getCell(cellRef);
      cell.alignment = { horizontal: 'center', vertical: 'middle' }; // Centers the text
      cell.font = { bold: true }; // Makes the text bold
    });

    ['A15', 'A16', 'A17'].forEach(cell => {
      worksheet.getCell(cell).font = { bold: true };
      worksheet.getCell(cell).alignment = { horizontal: 'right' };
    });


    ['A18'].forEach(cell => {
      worksheet.getCell(cell).alignment = { horizontal: 'left' };
    });


    worksheet.mergeCells('A18:M18');
    worksheet.mergeCells('A17:D17');
    worksheet.mergeCells('A16:D16');
    worksheet.mergeCells('A15:D15');
    worksheet.mergeCells('A20:D20');
    worksheet.mergeCells('A21:D21');
    worksheet.mergeCells('A3:D3');
    worksheet.mergeCells('A4:D4');
    worksheet.mergeCells('A5:D5');
    // worksheet.mergeCells('A6:C6');
    worksheet.mergeCells('A1:D2');
    worksheet.mergeCells('E4:M4');
    // worksheet.mergeCells('E6:G6');
    worksheet.mergeCells('A6:B6');
    worksheet.mergeCells('C6:D6');
    worksheet.mergeCells('E2:M2');
    worksheet.mergeCells('E3:M3');
    worksheet.mergeCells('A19:D19');
    worksheet.mergeCells('F19:M19');
    worksheet.mergeCells('A22:D22');
    worksheet.mergeCells('A23:D23');
    worksheet.mergeCells('A8:A10');
    worksheet.mergeCells('B8:B10');
    worksheet.mergeCells('C8:C10');
    worksheet.mergeCells('D8:D10');
    worksheet.mergeCells('F20:M20');
    worksheet.mergeCells('F21:M21');
    worksheet.mergeCells('F22:M22');
    worksheet.mergeCells('F23:M23');
    worksheet.mergeCells('E6:I6');
    worksheet.mergeCells('J6:M6');
    // Define rows to apply the font style
    const rows = [8, 9, 10];

    // Apply font style to each row
    rows.forEach(rowNumber => {
      worksheet.getRow(rowNumber).eachCell((cell) => {
        cell.font = { size: 10, bold: true };  // Set font size to 10 and make it bold
      });
    });

    ['A3', 'A4', 'A5', 'E3'].forEach(cell => {
      worksheet.getCell(cell).font = { bold: true };
    });

    ['A18', 'A19', 'A20', 'A21', 'A22', 'A23'].forEach(cell => {
      worksheet.getCell(cell).font = { size: 8, bold: true };
    });

    ['A6', 'C6'].forEach(cell => {
      worksheet.getCell(cell).font = { size: 9, bold: true };
    });


    const rowNumber = 10;


    // Set the height for the entire row (affects all cells in the row)
    worksheet.getRow(rowNumber).height = 40;  // Set height to 40 (adjust as needed)

    // Adjust cells starting from the 4th column (column D, index 4)
    for (let col = 5; col <= worksheet.columns.length; col++) {
      const cell = worksheet.getCell(rowNumber, col);
      cell.alignment = { wrapText: true };
      // You can further manipulate cell content or styling here if needed
    }

    const cell = worksheet.getCell('A20');
    worksheet.getRow(20).height = 25;
    cell.alignment = { wrapText: true };

    const cell1 = worksheet.getCell('A21');
    worksheet.getRow(21).height = 25;
    cell1.alignment = { wrapText: true };

    addBorders(worksheet);


    // Write the workbook to buffer
    const buffer = await workbook.xlsx.writeBuffer();

    // Save the workbook as a file
    const fileName = `${courseName}-${moduleCode}-Attendance.xlsx`;
    saveAs(new Blob([buffer]), fileName);
  };
  // const exportToExcel = async (weeksData, courseName, moduleCode, moduleName, intakeId, trainers, scheduleId, studentIntakeIds, nrics, intakeIds, names, studentIds) => {
  //   const workbook = new ExcelJS.Workbook();
  //   const worksheet = workbook.addWorksheet('Attendance Details');

  //    worksheet.pageSetup = {
  //      orientation: 'landscape',  
  //     //  printTitlesRow: '1:5',
  //      // Configure page setup to repeat row 5 on each pageS
  //    };

  //    worksheet.pageSetup.printTitlesColumn = 'A:D'; 

  //    worksheet.pageSetup.oddFooter = "hi";
  // const base64Image = await getImageAsBase64('/images/Juro.png');  // Use the correct image path

  // // Add the image to the workbook using the Base64 string
  // const imageId = workbook.addImage({
  //   base64: base64Image,  // Base64 image string
  //   extension: 'png',  // Image extension
  // });

  // // Insert the image into a specific cell (e.g., top-left corner)
  // worksheet.addImage(imageId, {
  //   tl: { col: 0, row: 0 }, // Position at top-left corner (A1 cell)
  //   ext: { width: 275, height: 38  ,}, // Resize image
  // });

  //   // Filter scheduleDetails based on provided scheduleId
  //   const selectedSchedule = studentdata[0]?.scheduleDateDetails.find(schedule => schedule.id === scheduleId);
  //   if (!selectedSchedule) {
  //     throw new Error(`Schedule with ID ${scheduleId} not found.`);
  //   }

  //   // Fetch attendance data for all dates in the schedule
  //   let allApiData = [];
  //   for (const week of selectedSchedule.weeks) {
  //     for (const date of week.dates) {
  //       const apiEndpoint = `by-intake-and-date?intakeId=${intakeId}&date=${date.date}`;
  //       try {
  //         const response = await axios.get(apiEndpoint);
  //         allApiData = [...allApiData, ...response.data];
  //       } catch (error) {
  //         console.error(`Error fetching data for date ${date.date}:`, error);
  //       }
  //     }
  //   }

  //   // Helper function to convert 24-hour time to 12-hour format
  //   const convertTo12HourFormat = (time24) => {
  //     const [hours, minutes] = time24.split(':').map(Number);
  //     const suffix = hours >= 12 ? 'PM' : 'AM';
  //     const hours12 = hours % 12 || 12; // Convert 0 hours (midnight) to 12
  //     const minutes12 = minutes.toString().padStart(2, '0');
  //     return `${hours12}:${minutes12} ${suffix}`;
  //   };

  //   // Helper function to normalize time (omit seconds for comparison)
  //   const normalizeTime = (time) => {
  //     const [timePart, suffix] = time.split(' ');
  //     const [hours, minutes] = timePart.split(':').map(Number);
  //     const normalizedTime = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')} ${suffix}`;
  //     return normalizedTime;
  //   };

  //   // Add headers and schedule details to the worksheet
  //   worksheet.addRow(['', '', '','',`${courseName}`,  '', '']);
  //   worksheet.addRow([`Module Code: ${moduleCode}`, '', '', '',  `Intake ID: ${intakeId}`]);
  //   worksheet.addRow([`Trainers: ${trainers.join(', ')}`, '', '', '', '', '']);
  //   const venue = selectedSchedule?.venue || 'Unknown Venue';
  //   worksheet.addRow([`Venue: ${venue}`, '', '', '', '', '']);
  //   const startDate = selectedSchedule?.startDate || 'Unknown Start Date';
  //   const endDate = selectedSchedule?.endDate || 'Unknown End Date';
  //   const row =worksheet.addRow([`Start Date: ${startDate}`,'', `End Date: ${endDate}`,'', "SCHEDULE FOR CLASS DATE", '','','','',`Total Hours: 70 hrs`,'','','']);
  //   row.getCell(5).font = { bold: true };
  //   // Add week headers and session details to the worksheet
  //   const scheduleDetailsRow1 = ['S.No', 'NAME', 'Nric/Fin No', 'IntakeID'];
  //   const scheduleDetailsRow2 = [];
  //   const dateRow = [];

  //   for (let i = 0; i < 4; i++) {
  //     scheduleDetailsRow2.push(''); // Fill the first 4 columns with placeholders
  //     dateRow.push('');
  //   }

  //   let currentColumnIndex = 5;

  //   selectedSchedule.weeks.forEach(week => {
  //     // Join all dates of the week into a single string (e.g., "2024-11-01, 2024-11-02")
  //     const weekDates = week.dates.map(date => date.date).join(', '); // Join multiple dates with commas
  //     const weekNumber = week.weekNumber || 'Unknown Week';
  //     // scheduleDetailsRow1.push(`${weekDates} Week ${weekNumber}`);
  //     // const weekHeader = `${weekDates} Week ${weekNumber}`;
  //     const weekHeader = `Week ${weekNumber}`;

  //     let sessionStatuses = [];
  //     let weekDatesForSession = []; // To store the date for each session

  //     week.dates.forEach(date => {
  //       if (date.sessions) {
  //         Object.keys(date.sessions).forEach(sessionName => {
  //           const session = date.sessions[sessionName];
  //           const startTime24 = session.startTime;
  //           const endTime24 = session.endTime;

  //           // Convert startTime and endTime to 12-hour format
  //           const startTime12 = convertTo12HourFormat(startTime24);
  //           const endTime12 = convertTo12HourFormat(endTime24);
  //           // sessionDetails += `${sessionName}: ${startTime12} - ${endTime12} | `;
  //           sessionStatuses.push(` ${startTime12}\n -\n ${endTime12}`);

  //             // Add the date corresponding to the session
  //         weekDatesForSession.push(date.date);
  //         });
  //       }
  //     });

  //     const sessionCount = sessionStatuses.length;

  //     scheduleDetailsRow1[currentColumnIndex - 1] = weekHeader;
  //     if (sessionCount > 1) {
  //       worksheet.mergeCells(1, currentColumnIndex, 1, currentColumnIndex + sessionCount - 1);
  //     }

  //     for (let i = 0; i < sessionCount; i++) {
  //       scheduleDetailsRow2[currentColumnIndex - 1 + i] = sessionStatuses[i];
  //     }

  //      // Add dates corresponding to each session in a separate row
  //   for (let i = 0; i < sessionCount; i++) {
  //     dateRow[currentColumnIndex - 1 + i] = weekDatesForSession[i];
  //   }

  //     // Update the currentColumnIndex for the next week
  //     currentColumnIndex += sessionCount;
  //   });
  //   worksheet.addRow(scheduleDetailsRow1); // Header row
  //   worksheet.addRow(dateRow);
  // worksheet.addRow(scheduleDetailsRow2); // Session details row

  //  worksheet.insertRow(7); // Empty row for spacing

  //   // Initialize week attendance counters for each week
  //   const weekAttendanceCounts = selectedSchedule.weeks.map(() => ({
  //     present: 0,
  //     absent: 0
  //   }));

  //   // Loop through students and match with API data
  //   const maxLength = Math.max(studentIds.length, nrics.length, intakeIds.length);
  //   for (let i = 0; i < maxLength; i++) {
  //     const studentId = studentIds[i] || '';
  //     const intakeId = intakeIds[i] || '';
  //     const nric = nrics[i] || '';
  //     const name = names[i] || '';

  //     const studentRow = [studentId, name, nric, intakeId];
  //     selectedSchedule.weeks.forEach((week, weekIndex) => {
  //       week.dates.forEach(date => {
  //         // Get all matching records for the current date, not just the first one
  //         const matchingRecords = allApiData.filter(record =>
  //           record.intakeId === intakeId &&
  //           record.custom_participant_id === String(studentId) &&
  //           record.date === date.date &&
  //           record.preset_name === "group_call_participant"

  //         );
  // console.log(matchingRecords,"matchingRecordsmatchingRecords");
  //         // Initialize session status array
  //         let sessionStatuses = [];
  //         if (matchingRecords.length > 0) {
  //           // Iterate over sessions for the date
  //           if (date.sessions) {
  //             Object.keys(date.sessions).forEach(sessionName => {
  //               const session = date.sessions[sessionName];
  //               const startTime24 = session.startTime;

  //               // Convert session start time to 12-hour format and normalize
  //               const startTime12 = convertTo12HourFormat(startTime24);
  //               const normalizedSessionStartTime = normalizeTime(startTime12);

  //               let sessionMatched = false; // Flag to track if session time matched any record
  //               // Helper function to convert 12-hour time format to Date object (today's date)
  // const convertToDateTime = (time) => {
  // const [timePart, suffix] = time.split(' '); // Split into time and AM/PM suffix
  // const [hours, minutes] = timePart.split(':').map(Number);

  // // Create a new Date object for today, set to the provided time
  // const date = new Date();
  // date.setHours(hours % 12 + (suffix === 'PM' ? 12 : 0), minutes, 0, 0);

  // return date;
  // };

  // // Function to check if two times are within ±15 minutes
  // const isWithin15Minutes = (startTime, recordTime) => {
  // const sessionTime = convertToDateTime(startTime); // Session start time
  // const recordDateTime = convertToDateTime(recordTime); // Record time

  // // Calculate the difference in milliseconds
  // const differenceInMilliseconds = Math.abs(sessionTime - recordDateTime);

  // // 15 minutes in milliseconds
  // const fifteenMinutesInMilliseconds = 15 * 60 * 1000;

  // // Return true if the difference is within 15 minutes
  // return differenceInMilliseconds <= fifteenMinutesInMilliseconds;
  // };


  //               // Check each matching record to see if the session start time matches
  //               matchingRecords.forEach(matchingRecord => {
  //                 const normalizedSessionTime = normalizeTime(matchingRecord.meeting_start_time);

  //                 // If the session start time matches the API record time, get the status
  //                 if (isWithin15Minutes(normalizedSessionStartTime, normalizedSessionTime)) {
  //                   const status = matchingRecord.status || '-'; // If null or empty, mark as '-'
  //                   sessionStatuses.push(` ${status}`);
  //                   sessionMatched = true;

  //                   // Count present and absent, excluding '-'
  //                   if (status === 'P') {
  //                     weekAttendanceCounts[weekIndex].present++;
  //                   } else if (status === 'AB') {
  //                     weekAttendanceCounts[weekIndex].absent++;
  //                   }
  //                 }
  //               });

  //               // If no matching session time was found, mark the session as absent ('-')
  //               if (!sessionMatched) {
  //                 sessionStatuses.push(` AB`);

  //               }
  //             });
  //           }
  //         }

  //         // If no sessions were matched, mark as '-'
  //         if (sessionStatuses.length === 0) {
  //           if (date.sessions) {
  //             Object.keys(date.sessions).forEach(sessionName => {
  //               sessionStatuses.push(` -`); // Mark as '-' for each session
  //             });
  //           }

  //         }
  //         studentRow.push(...sessionStatuses);
  //         // Append session statuses to student row
  //         // studentRow.push(sessionStatuses.join(' | '));
  //       });
  //     });

  //     worksheet.addRow(studentRow); // Add the row to the worksheet
  //   }

  //   const presentAbsentRow = ['No. of Present for Week', '', '', '', ...weekAttendanceCounts.map(count => count.present)];
  //   worksheet.addRow(presentAbsentRow);
  //   const absentRow = ['No. of Absent for Week', '', '', '', ...weekAttendanceCounts.map(count => count.absent)];
  //   worksheet.addRow(absentRow);

  //   // Add other footer information
  //   worksheet.addRow(['Signature of Teacher:', '', '', '', '', '']);
  //   worksheet.addRow(['Note for course Lectures / course facilitators and students:']);
  //   worksheet.addRow(['Reminder:','','','','','VERIFIED BY: _____________________']);
  //   worksheet.addRow(['Lecturers are required to authenticate attendance for every student after the completion of each class', '', '','', '', 'DESIGNATION: Training Manager']);
  //   worksheet.addRow(['Lecturers are also required to mark attendance of students who are absent or late for lessons', '', '','', '', 'DATE:']);
  //   worksheet.addRow(['Students are required to sign in the appropriate columns', '', '', '', '', 'NAME: RABIYATHUL BASARIYA A']);
  //   worksheet.addRow(['AB: Absent / P: Present / -:Session Not Taken Yet', '', '', '', '', '']);

  // // Define the cell references
  // const cells = ['A8', 'B8', 'C8', 'D8','E2','D19'];

  // // Apply font style and alignment to each cell
  // cells.forEach(cellRef => {
  //   const cell = worksheet.getCell(cellRef);
  //   cell.alignment = { horizontal: 'center', vertical: 'middle' }; // Centers the text
  //   cell.font = { bold: true }; // Makes the text bold
  // });

  //   ['A15', 'A16', 'A17'].forEach(cell => {
  //     worksheet.getCell(cell).font = { bold: true };
  //     worksheet.getCell(cell).alignment = { horizontal: 'right' };
  //   });


  //   ['A18'].forEach(cell => {
  //     worksheet.getCell(cell).alignment = { horizontal: 'left' };
  //   });


  //   worksheet.mergeCells('A18:M18');
  //   worksheet.mergeCells('A17:D17');
  //   worksheet.mergeCells('A16:D16');
  //   worksheet.mergeCells('A15:D15');
  //   worksheet.mergeCells('A20:D20');
  //   worksheet.mergeCells('A21:D21');
  //   worksheet.mergeCells('A3:D3');
  //   worksheet.mergeCells('A4:D4');
  //   worksheet.mergeCells('A5:D5');
  //   // worksheet.mergeCells('A6:C6');
  //   worksheet.mergeCells('A1:D2'); 
  //   worksheet.mergeCells('E4:M4');
  //   // worksheet.mergeCells('E6:G6');
  //   worksheet.mergeCells('A6:B6');
  //   worksheet.mergeCells('C6:D6');
  //   worksheet.mergeCells('E2:M2');
  //   worksheet.mergeCells('E3:M3');
  //   worksheet.mergeCells('A19:D19');
  //   worksheet.mergeCells('F19:M19');
  //   worksheet.mergeCells('A22:D22');
  //   worksheet.mergeCells('A23:D23');
  //   worksheet.mergeCells('A8:A10');
  //   worksheet.mergeCells('B8:B10');
  //   worksheet.mergeCells('C8:C10');
  //   worksheet.mergeCells('D8:D10');
  //   worksheet.mergeCells('F20:M20');
  //   worksheet.mergeCells('F21:M21');
  //   worksheet.mergeCells('F22:M22');
  //   worksheet.mergeCells('F23:M23');
  //   worksheet.mergeCells('E6:I6');
  //   worksheet.mergeCells('J6:M6');
  // // Define rows to apply the font style
  // const rows = [8, 9, 10];

  // // Apply font style to each row
  // rows.forEach(rowNumber => {
  //   worksheet.getRow(rowNumber).eachCell((cell) => {
  //     cell.font = { size: 10, bold: true };  // Set font size to 10 and make it bold
  //   });
  // });

  // ['A3', 'A4', 'A5','E3'].forEach(cell => {
  //   worksheet.getCell(cell).font = { bold: true };
  // });

  // ['A18', 'A19', 'A20', 'A21','A22','A23'].forEach(cell => {
  //   worksheet.getCell(cell).font = { size: 8, bold: true };
  // });

  // ['A6','C6'].forEach(cell => {
  //   worksheet.getCell(cell).font = { size: 9, bold: true };
  // });


  // const rowNumber = 10;


  // // Set the height for the entire row (affects all cells in the row)
  // worksheet.getRow(rowNumber).height = 40;  // Set height to 40 (adjust as needed)

  // // Adjust cells starting from the 4th column (column D, index 4)
  // for (let col = 5; col <= worksheet.columns.length; col++) {
  //   const cell = worksheet.getCell(rowNumber, col);
  //   cell.alignment = { wrapText: true }; 
  //   // You can further manipulate cell content or styling here if needed
  // }

  // const cell = worksheet.getCell('A20');
  // worksheet.getRow(20).height = 25;
  // cell.alignment = { wrapText: true };  

  // const cell1 = worksheet.getCell('A21');
  // worksheet.getRow(21).height = 25;
  // cell1.alignment = { wrapText: true };  

  //   addBorders(worksheet);


  //   // Write the workbook to buffer
  //   const buffer = await workbook.xlsx.writeBuffer();

  //   // Save the workbook as a file
  //   const fileName = `${courseName}-${moduleCode}-Attendance.xlsx`;
  //   saveAs(new Blob([buffer]), fileName);
  // };
  // After you've populated your worksheet with data, call this function     
  // const exportToExcel = async (weeksData, courseName, moduleCode, moduleName, intakeId, trainers, scheduleId, studentIntakeIds, nrics, intakeIds, names, studentIds) => {
  //   const workbook = new ExcelJS.Workbook();
  //   const worksheet = workbook.addWorksheet('Attendance Details');

  // const base64Image = await getImageAsBase64('/images/Juro.png');  // Use the correct image path

  // // Add the image to the workbook using the Base64 string
  // const imageId = workbook.addImage({
  //   base64: base64Image,  // Base64 image string
  //   extension: 'png',  // Image extension
  // });

  // // Insert the image into a specific cell (e.g., top-left corner)
  // worksheet.addImage(imageId, {
  //   tl: { col: 0, row: 0 }, // Position at top-left corner (A1 cell)
  //   ext: { width: 275, height: 38  ,}, // Resize image
  // });

  //   // Filter scheduleDetails based on provided scheduleId
  //   const selectedSchedule = studentdata[0]?.scheduleDateDetails.find(schedule => schedule.id === scheduleId);
  //   if (!selectedSchedule) {
  //     throw new Error(`Schedule with ID ${scheduleId} not found.`);
  //   }

  //   // Fetch attendance data for all dates in the schedule
  //   let allApiData = [];
  //   for (const week of selectedSchedule.weeks) {
  //     for (const date of week.dates) {
  //       const apiEndpoint = `by-intake-and-date?intakeId=${intakeId}&date=${date.date}`;
  //       try {
  //         const response = await axios.get(apiEndpoint);
  //         allApiData = [...allApiData, ...response.data];
  //       } catch (error) {
  //         console.error(`Error fetching data for date ${date.date}:`, error);
  //       }
  //     }
  //   }

  //   // Helper function to convert 24-hour time to 12-hour format
  //   const convertTo12HourFormat = (time24) => {
  //     const [hours, minutes] = time24.split(':').map(Number);
  //     const suffix = hours >= 12 ? 'PM' : 'AM';
  //     const hours12 = hours % 12 || 12; // Convert 0 hours (midnight) to 12
  //     const minutes12 = minutes.toString().padStart(2, '0');
  //     return `${hours12}:${minutes12} ${suffix}`;
  //   };

  //   // Helper function to normalize time (omit seconds for comparison)
  //   const normalizeTime = (time) => {
  //     const [timePart, suffix] = time.split(' ');
  //     const [hours, minutes] = timePart.split(':').map(Number);
  //     const normalizedTime = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')} ${suffix}`;
  //     return normalizedTime;
  //   };

  //   // Add headers and schedule details to the worksheet
  //   worksheet.addRow(['', '', '','',`${courseName}`,  '', '']);
  //   worksheet.addRow([`Module Code: ${moduleCode}`, '', '', '', '', '', `Intake ID: ${intakeId}`]);
  //   worksheet.addRow([`Trainers: ${trainers.join(', ')}`, '', '', '', '', '']);
  //   const venue = selectedSchedule?.venue || 'Unknown Venue';
  //   worksheet.addRow([`Venue: ${venue}`, '', '', '', '', '']);
  //   const startDate = selectedSchedule?.startDate || 'Unknown Start Date';
  //   const endDate = selectedSchedule?.endDate || 'Unknown End Date';
  //   const row =worksheet.addRow([`Start Date: ${startDate}`, `End Date: ${endDate}`, `Total Hours: 70 hrs`, '',"SCHEDULE FOR CLASS DATE"]);
  //   row.getCell(5).font = { bold: true };
  //   // Add week headers and session details to the worksheet
  //   const scheduleDetailsRow1 = ['S.No', 'NAME', 'Nric/Fin No', 'IntakeID'];
  //   const scheduleDetailsRow2 = [];
  //   selectedSchedule.weeks.forEach(week => {
  //     // Join all dates of the week into a single string (e.g., "2024-11-01, 2024-11-02")
  //     const weekDates = week.dates.map(date => date.date).join(', '); // Join multiple dates with commas
  //     const weekNumber = week.weekNumber || 'Unknown Week';
  //     scheduleDetailsRow1.push(`${weekDates} Week ${weekNumber}`);
  //     let sessionDetails = '';
  //     week.dates.forEach(date => {
  //       if (date.sessions) {
  //         Object.keys(date.sessions).forEach(sessionName => {
  //           const session = date.sessions[sessionName];
  //           const startTime24 = session.startTime;
  //           const endTime24 = session.endTime;

  //           // Convert startTime and endTime to 12-hour format
  //           const startTime12 = convertTo12HourFormat(startTime24);
  //           const endTime12 = convertTo12HourFormat(endTime24);
  //           // sessionDetails += `${sessionName}: ${startTime12} - ${endTime12} | `;
  //           sessionDetails += `${startTime12} - ${endTime12} \n| \n`;
  //         });
  //       }
  //     });
  //     scheduleDetailsRow2.push(sessionDetails.trim().replace(/ \|$/, '') || '');
  //   });

  //   // Add 4 empty columns at the start of the row
  //   const updatedScheduleDetailsRow2 = ['', '', '', '', ...scheduleDetailsRow2];

  //   worksheet.addRow(scheduleDetailsRow1); // Row for header labels
  //   worksheet.addRow(updatedScheduleDetailsRow2); // Row for session details with 4 empty columns
  //   // worksheet.insertRow(7); // Empty row for spacing
  //   // worksheet.addRow('','','','',"SCHEDULE FOR CLASS DATE"); // Empty row for spacing

  //   // Initialize week attendance counters for each week
  //   const weekAttendanceCounts = selectedSchedule.weeks.map(() => ({
  //     present: 0,
  //     absent: 0
  //   }));

  //   // Loop through students and match with API data
  //   const maxLength = Math.max(studentIds.length, nrics.length, intakeIds.length);
  //   for (let i = 0; i < maxLength; i++) {
  //     const studentId = studentIds[i] || '';
  //     const intakeId = intakeIds[i] || '';
  //     const nric = nrics[i] || '';
  //     const name = names[i] || '';

  //     const studentRow = [studentId, name, nric, intakeId];
  //     selectedSchedule.weeks.forEach((week, weekIndex) => {
  //       week.dates.forEach(date => {
  //         // Get all matching records for the current date, not just the first one
  //         const matchingRecords = allApiData.filter(record =>
  //           record.intakeId === intakeId &&
  //           record.custom_participant_id === String(studentId) &&
  //           record.date === date.date
  //         );

  //         // Initialize session status array
  //         let sessionStatuses = [];
  //         if (matchingRecords.length > 0) {
  //           // Iterate over sessions for the date
  //           if (date.sessions) {
  //             Object.keys(date.sessions).forEach(sessionName => {
  //               const session = date.sessions[sessionName];
  //               const startTime24 = session.startTime;

  //               // Convert session start time to 12-hour format and normalize
  //               const startTime12 = convertTo12HourFormat(startTime24);
  //               const normalizedSessionStartTime = normalizeTime(startTime12);

  //               let sessionMatched = false; // Flag to track if session time matched any record
  //               // Helper function to convert 12-hour time format to Date object (today's date)
  // const convertToDateTime = (time) => {
  // const [timePart, suffix] = time.split(' '); // Split into time and AM/PM suffix
  // const [hours, minutes] = timePart.split(':').map(Number);

  // // Create a new Date object for today, set to the provided time
  // const date = new Date();
  // date.setHours(hours % 12 + (suffix === 'PM' ? 12 : 0), minutes, 0, 0);

  // return date;
  // };

  // // Function to check if two times are within ±15 minutes
  // const isWithin15Minutes = (startTime, recordTime) => {
  // const sessionTime = convertToDateTime(startTime); // Session start time
  // const recordDateTime = convertToDateTime(recordTime); // Record time

  // // Calculate the difference in milliseconds
  // const differenceInMilliseconds = Math.abs(sessionTime - recordDateTime);

  // // 15 minutes in milliseconds
  // const fifteenMinutesInMilliseconds = 15 * 60 * 1000;

  // // Return true if the difference is within 15 minutes
  // return differenceInMilliseconds <= fifteenMinutesInMilliseconds;
  // };


  //               // Check each matching record to see if the session start time matches
  //               matchingRecords.forEach(matchingRecord => {
  //                 const normalizedSessionTime = normalizeTime(matchingRecord.time);

  //                 // If the session start time matches the API record time, get the status
  //                 if (isWithin15Minutes(normalizedSessionStartTime, normalizedSessionTime)) {
  //                   const status = matchingRecord.status || '-'; // If null or empty, mark as '-'
  //                   // sessionStatuses.push(`${sessionName}: ${status}`);
  //                   sessionStatuses.push(`${status}`);
  //                   sessionMatched = true;

  //                   // Count present and absent, excluding '-'
  //                   if (status === 'P') {
  //                     weekAttendanceCounts[weekIndex].present++;
  //                   } else if (status === 'AB') {
  //                     weekAttendanceCounts[weekIndex].absent++;
  //                   }
  //                 }
  //               });

  //               // If no matching session time was found, mark the session as absent ('-')
  //               if (!sessionMatched) {
  //                 sessionStatuses.push(`${sessionName}: -`);
  //               }
  //             });
  //           }
  //         }

  //         // If no sessions were matched, mark as '-'
  //         if (sessionStatuses.length === 0) {
  //           sessionStatuses.push('-');
  //         }

  //         // Append session statuses to student row
  //         studentRow.push(sessionStatuses.join(' | '));
  //       });
  //     });

  //     worksheet.addRow(studentRow); // Add the row to the worksheet
  //   }

  //   // Add Present/Absent counts in a single row for each week in columns
  //   // const presentAbsentRow = ['No. of Present for Week', ...weekAttendanceCounts.map(count => count.present)];
  //   // worksheet.addRow(presentAbsentRow);
  //   // const absentRow = ['No. of Absent for Week', ...weekAttendanceCounts.map(count => count.absent)];
  //   // worksheet.addRow(absentRow);

  //   const presentAbsentRow = ['No. of Present for Week', '', '', '', ...weekAttendanceCounts.map(count => count.present)];
  //   worksheet.addRow(presentAbsentRow);
  //   const absentRow = ['No. of Absent for Week', '', '', '', ...weekAttendanceCounts.map(count => count.absent)];
  //   worksheet.addRow(absentRow);

  //   // Add other footer information
  //   worksheet.addRow(['Signature of Teacher:', '', '', '', '', '']);
  //   worksheet.addRow(['Note for course Lectures / course facilitators and students:', '', '', '', '', '']);
  //   worksheet.addRow(['Reminder:',  '', '', '', '','VERIFIED BY: _____________________']);
  //   worksheet.addRow(['Lecturers are required to authenticate attendance for every student after the completion of each class', '', '','', '', 'DESIGNATION: Training Manager']);
  //   worksheet.addRow(['Lecturers are also required to mark attendance of students who are absent or late for lessons', '', '','', '', 'DATE:']);
  //   worksheet.addRow(['Students are required to sign in the appropriate columns', '', '', '', '', 'NAME: RABIYATHUL BASARIYA A']);
  //   worksheet.addRow(['AB: Absent / P: Present / -:Session Not Taken Yet', '', '', '', '', '']);

  //   // Adjust column widths
  //   // worksheet.getColumn(1).width = 40;
  //   // worksheet.getColumn(2).width = 25;
  //   // worksheet.getColumn(3).width = 25;
  //   // worksheet.getColumn(4).width = 25;
  //   // worksheet.getColumn(5).width = 30;
  //   // worksheet.getColumn(6).width = 30;
  //   // worksheet.getColumn(7).width = 30;
  //   // worksheet.getColumn(8).width = 30;
  //   // worksheet.getColumn(9).width = 30;
  //   // worksheet.getColumn(10).width = 30;
  //   // worksheet.getColumn(11).width = 30;
  //   // worksheet.getColumn(12).width = 30;
  //   worksheet.getRow(8).eachCell((cell, colNumber) => {
  //     cell.alignment = { wrapText: true }; 
  //     cell.font = { size: 8 }; // Enable text wrapping for the cell
  //   });
  //   // Write the workbook to buffer
  //   const buffer = await workbook.xlsx.writeBuffer();

  //   // Save the workbook as a file
  //   const fileName = `${courseName}-${moduleCode}-Attendance.xlsx`;
  //   saveAs(new Blob([buffer]), fileName);
  // };


  if (loading) return <CircularProgress />;
  if (error) return <Typography color="error">{error}</Typography>;


  const convertTo24HourFormat = (time12h) => {
    const [time, modifier] = time12h.split(" ");
    const [hours, minutes] = time.split(":").map(Number);

    let newHours = hours;
    if (modifier === "pm" && hours !== 12) newHours += 12;
    if (modifier === "am" && hours === 12) newHours = 0;

    return `${String(newHours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
  }

  // Function to handle adding a new session to a date
  const handleAddSession = (weekId, dateId) => {
    const updatedWeeks = editableWeeks.map((week) => {
      if (week.id === weekId) {
        const updatedDates = week.dates.map((date) => {
          if (date.id === dateId) {
            const newSessionName = `Session ${Object.keys(date.sessions || {}).length + 1}`;
            const updatedSessions = {
              ...date.sessions,
              [newSessionName]: { startTime: ' ', endTime: ' ' },
            };
            return { ...date, sessions: updatedSessions };
          }
          return date;
        });
        return { ...week, dates: updatedDates };
      }
      return week;
    });

    setEditableWeeks(updatedWeeks);
  };


  // Function to handle deleting a session from a date
  const handleDeleteSession = (weekId, dateId, sessionName) => {
    const updatedWeeks = editableWeeks.map((week) => {
      if (week.id === weekId) {
        const updatedDates = week.dates.map((date) => {
          if (date.id === dateId) {
            // Remove the session
            const updatedSessions = { ...date.sessions };
            delete updatedSessions[sessionName];

            // Re-index the remaining sessions
            const reindexedSessions = {};
            Object.keys(updatedSessions)
              .sort()  // Sort sessions by their name to ensure they are ordered
              .forEach((key, index) => {
                // Renumber the session
                reindexedSessions[`Session ${index + 1}`] = updatedSessions[key];
              });

            return { ...date, sessions: reindexedSessions };
          }
          return date;
        });
        return { ...week, dates: updatedDates };
      }
      return week;
    });

    setEditableWeeks(updatedWeeks);
  };


  return (
    <Box sx={{ width: '100%', padding: 2 }}>
      <Typography variant="h4" gutterBottom>
        Intake Details
      </Typography>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Intake ID</TableCell>
              <TableCell>Batch ID</TableCell>
              <TableCell>Course</TableCell>
              <TableCell>Type</TableCell>

              <TableCell>Start Date</TableCell>
              <TableCell>End Date</TableCell>
              <TableCell>Trainer</TableCell>
              <TableCell>Venue</TableCell>
              <TableCell>Start Modulus</TableCell>
              <TableCell>Weeks</TableCell>
              <TableCell>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {studentdata.flatMap((student) =>
              student.scheduleDateDetails.map((schedule) => (
                <TableRow key={schedule.id}>
                  <TableCell>{student.intakeId}</TableCell>
                  <TableCell>{student.batchId}</TableCell>
                  <TableCell>{student.course}</TableCell>
                  <TableCell>{student.type}</TableCell>

                  <TableCell>{schedule.startDate}</TableCell>
                  <TableCell>{schedule.endDate}</TableCell>
                  <TableCell>{schedule.trainer}</TableCell>
                  <TableCell>{schedule.venue}</TableCell>
                  <TableCell>{schedule.startModulus}</TableCell>
                  <TableCell>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() => handleClickOpen(schedule.weeks, schedule.id, student.id)}
                    >
                      View Weeks
                    </Button>
                  </TableCell>
                  <TableCell> <Button
                    variant="contained"
                    color="primary"
                    onClick={() => handleOpenModal(schedule.id)}
                  >
                    Edit Module
                  </Button>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <Dialog open={open} onClose={handleClose} fullWidth maxWidth="md">
        <DialogTitle>Week Details</DialogTitle>
        <DialogContent sx={{ overflowY: 'auto' }}>
          {editableWeeks.length ? (
            editableWeeks.map((week) => (
              <Box key={week.id} sx={{ marginBottom: 3 }}>
                <Typography
                  variant="h6"
                  sx={{
                    cursor: 'pointer',
                    fontWeight: 'bold',
                    color: '#3f51b5',
                    marginBottom: 1
                  }}
                  onClick={() => handleWeekSelection(week)}
                >
                  Week {week.weekNumber}
                </Typography>

                {/* Show dates if the week is selected */}
                {selectedWeek === week.id && week.dates && week.dates.length ? (
                  week.dates.map((date) => (
                    <Box key={date.id} sx={{ marginBottom: 3 }}>
                      <Typography
                        variant="subtitle1"
                        sx={{
                          cursor: 'pointer',
                          fontWeight: 'bold',
                          color: '#1976d2',
                          marginBottom: 1
                        }}
                        onClick={() => handleDateSelection(date)}
                      >
                        Date: {date.date}
                      </Typography>

                      {/* Show session details if the date is selected */}
                      {selectedDate === date.id && (
                        <>
                          <Grid container spacing={2}>
                            <Grid item xs={12} sm={6}>
                              <TextField
                                type="date"
                                label="Date"
                                variant="outlined"
                                fullWidth
                                value={date.date}
                                onChange={(e) => handleDateChange(e, week.id, date.id)}
                                sx={{ marginBottom: 1 }}
                                InputLabelProps={{ shrink: true }}
                              />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <TextField
                                label="Day"
                                variant="outlined"
                                fullWidth
                                value={date.day}
                                // onChange={(e) => handleDayChange(e, week.id, date.id)}
                                sx={{ marginBottom: 1 }}
                              />
                            </Grid>
                          </Grid>

                          {/* Sessions Section */}
                          {Object.entries(date.sessions || {})
                            .sort((a, b) => {
                              // Extract numeric part from session names and compare
                              const sessionNumberA = parseInt(a[0].replace('Session ', ''));
                              const sessionNumberB = parseInt(b[0].replace('Session ', ''));
                              return sessionNumberA - sessionNumberB;
                            })
                            .map(([sessionName, session]) => (
                              <Box key={sessionName} sx={{ position: 'relative', marginBottom: 2 }}>
                                <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
                                  Session: {sessionName}
                                </Typography>
                                <Grid container spacing={2}>
                                  <Grid item xs={5} sm={5}>
                                    <TextField
                                      label="Start Time"
                                      type="time"
                                      variant="outlined"
                                      fullWidth
                                      value={session.startTime ? convertTo24HourFormat(session.startTime) : '00:00'}
                                      onChange={(e) => handleStartTimeChange(e, week.id, date.id, sessionName)}
                                      sx={{ marginBottom: 1 }}
                                      InputLabelProps={{ shrink: true }}
                                    />
                                  </Grid>
                                  <Grid item xs={5}>
                                    <TextField
                                      label="End Time"
                                      type="time"
                                      variant="outlined"
                                      fullWidth
                                      value={session.endTime ? convertTo24HourFormat(session.endTime) : '00:00'}
                                      onChange={(e) => handleEndTimeChange(e, week.id, date.id, sessionName)}
                                      sx={{ marginBottom: 1 }}
                                      InputLabelProps={{ shrink: true }}
                                    />
                                  </Grid>
                                  <Grid item xs={1}>
                                    <IconButton
                                      onClick={() => handleDeleteSession(week.id, date.id, sessionName)}
                                    >
                                      <Delete color="error" />
                                    </IconButton>
                                  </Grid>
                                </Grid>
                              </Box>
                            ))}

                          {/* Add icon to add a new session */}
                          <Box sx={{ marginTop: 2 }}>
                            <Button
                              startIcon={<Add />}
                              variant="contained"
                              color="primary"
                              sx={{ marginTop: 1 }}
                              onClick={() => handleAddSession(week.id, date.id)}
                            >
                              Add Session
                            </Button>

                            <Button
                              variant="contained"
                              color="success"
                              sx={{ marginTop: 1, marginLeft: 1 }}
                              onClick={handleSaveChanges}
                            >
                              Save
                            </Button>
                          </Box>
                          {/* <ToastContainer /> */}
                        </>

                      )}
                    </Box>
                  ))
                ) : (
                  <Typography></Typography>
                )}
              </Box>
            ))
          ) : (
            <Typography>No week data available</Typography>
          )}

        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            color="secondary"
            sx={{ paddingX: 4 }}
            onClick={() => {
              const courseName = studentdata[0]?.course || 'Unknown Course';
              const moduleCode = studentdata[0]?.id || 'Unknown Code';
              const moduleName = studentdata[0]?.moduleName || 'Unknown Module';
              const intakeId = studentdata[0]?.intakeId || 'Unknown Intake';
              const trainers = studentdata[0]?.trainers || [];
              const scheduleId = selectedScheduleId; // Example schedule ID

              // Collect studentIntakeId values
              const studentIntakeIds = studentdata1.map((student) => student.studentIntakeId || 'Unknown Intake ID');
              const nrics = studentdata1.map((student) => student.nric || 'Unknown Intake ID');
              const intakeIds = studentdata1.map((student) => student.intakeId || 'Unknown Intake ID');
              const studentIds = studentdata1.map((student) => student.id || 'Unknown Intake ID');
              const names = studentdata1.map((student) => student.name || 'Unknown Intake ID');
              // console.log('studentIntakeIds:', studentIds);

              exportToExcel(editableWeeks, courseName, moduleCode, moduleName, intakeId, trainers, scheduleId, studentIntakeIds, nrics, intakeIds, names, studentIds);
            }}
          >
            Export to Excel
          </Button>
          <Button onClick={handleClose} color="primary" variant="contained">
            Close
          </Button>
        </DialogActions>

      </Dialog>

      <Dialog
        open={openModuleModal}
        onClose={handleCloseModal}
        maxWidth="md"
        fullWidth
      >
        {/* Dialog Header */}
        <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Typography variant="h6">Change Module Details</Typography>
          <IconButton onClick={handleCloseModal}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        {/* Dialog Body */}
        <DialogContent dividers>
          <EditSessionModule selectedScheduleId={selectedScheduleId} />
        </DialogContent>

        {/* Dialog Footer */}
        <DialogActions>
          <Button onClick={handleCloseModal} variant="contained">
            Close
          </Button>
        </DialogActions>
      </Dialog>
      <ToastContainer />
    </Box>
  );
};

export default AttendanceSheet;
